export const monitoraggioHead = [
	{id: "id", numeric: false, disablePadding: false, label: "Id"},
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data creazione"},
	{id: "stato", numeric: false, disablePadding: false, label: "Stato"},
	{id: "categoria", numeric: false, disablePadding: false, label: "Categoria"},
];

export const tamponiHead = [
	{id: "codF", numeric: false, disablePadding: true, label: "Codice fiscale"},
	{id: "dataEsito", numeric: false, disablePadding: false, label: "Data tampone"},
	{id: "motivazione", numeric: false, disablePadding: false, label: "Motivazione"},
	{id: "laboratorio", numeric: false, disablePadding: false, label: "Laboratorio"},
	{id: "medicoRichiedente", numeric: false, disablePadding: false, label: "Medico Richiedente"},
	{id: "gestisci", numeric: false, disablePadding: false, label: "Gestione"},
];

export const intervistaHead = [
	{id: "id", numeric: false, disablePadding: false, label: "Id intervista"},
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "paziente", numeric: false, disablePadding: false, label: "Paziente"},
	{id: "dataInserimento", numeric: false, disablePadding: false, label: "Data inserimento"},
	{id: "cell", numeric: false, disablePadding: false, label: "Cellulare"},
];

export const intervisteOperatoreHead = [
	{id: "id", numeric: true, disablePadding: false, label: "Id intervista"},
	{id: "dataInserimento", numeric: false, disablePadding: false, label: "Data inserimento"},
	{id: "dataInizioIsolamento", numeric: false, disablePadding: false, label: "Data inizio isolamento / quarantena"},
	{id: "lastModify", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "soggetti", numeric: true, disablePadding: false, label: "N° pazienti"},
];

export const quarantenaHead = [
	{id: "id", numeric: false, disablePadding: false, label: "Id quarantena"},
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "paziente", numeric: false, disablePadding: false, label: "Paziente"},
	{id: "cell", numeric: false, disablePadding: false, label: "Cellulare"},
	{id: "dataInizio", numeric: false, disablePadding: false, label: "Data inizio"},
	{id: "dataFine", numeric: false, disablePadding: false, label: "Data fine"},
	{id: "tipo", numeric: false, disablePadding: false, label: "Tipo"},
	{id: "tipoMonitoraggio", numeric: false, disablePadding: false, label: "Tipo monitoraggio"},
];

export const anagraficaHead = [
	{id: "idSoggetto", numeric: false, disablePadding: false, label: "ID"},
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "tipoDocumento", numeric: false, disablePadding: false, label: "Tipo documento"},
	{id: "documento", numeric: false, disablePadding: false, label: "Valore documento"},
	{id: "nome", numeric: false, disablePadding: false, label: "Nome"},
	{id: "cognome", numeric: false, disablePadding: false, label: "Cognome"},
	{id: "sesso", numeric: false, disablePadding: false, label: "Sesso"},
	{id: "dataNascita", numeric: false, disablePadding: false, label: "Data nascita"},
	{id: "cell", numeric: false, disablePadding: false, label: "Cellulare"},
	{id: "email", numeric: false, disablePadding: false, label: "Email"},
	{id: "indirizzoDomicilio", numeric: false, disablePadding: false, label: "Domicilio"},
	{id: "indirizzoResidenza", numeric: false, disablePadding: false, label: "Residenza"},
	{id: "comuneNascita", numeric: false, disablePadding: false, label: "Comune di nascita"},
	{id: "domASL", numeric: false, disablePadding: false, label: "Asl di domicilio"},
	{id: "resASL", numeric: false, disablePadding: false, label: "Asl di residenza"},
];

export const medicoHead = [
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "nome", numeric: false, disablePadding: false, label: "Nome"},
	{id: "cognome", numeric: false, disablePadding: false, label: "Cognome"},
	{id: "cell", numeric: false, disablePadding: false, label: "Cellulare"},
	{id: "fisso", numeric: false, disablePadding: false, label: "Fisso"},
	{id: "email", numeric: false, disablePadding: false, label: "Email"},
]

export const segnalazioniHead = [
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data creazione"},
	{id: "cell", numeric: false, disablePadding: false, label: "Telefono"},
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "sottoCategoria", numeric: false, disablePadding: false, label: "Categoria"},
	{id: "priority", numeric: false, disablePadding: false, label: "Priorità"},
	{id: "lastModify", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "active", numeric: false, disablePadding: false, label: "In uso"},
	{id: "inviataMail", numeric: false, disablePadding: false, label: "Mail"},
	{id: "dataUltimaModifica", numeric: false, disablePadding: false, label: "Ultima modifica"},
];

export const segnalazioniAOHead = [
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data creazione"},
	{id: "src", numeric: false, disablePadding: false, label: "Mittente"},
	{id: "dst", numeric: false, disablePadding: false, label: "Destinatario"},
	{id: "sottoCategoria", numeric: false, disablePadding: false, label: "Categoria"},
	{id: "priority", numeric: false, disablePadding: false, label: "Priorità"},
	{id: "lastModify", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "active", numeric: false, disablePadding: false, label: "In uso"},
	{id: "inviataMail", numeric: false, disablePadding: false, label: "Mail"},
	{id: "dataUltimaModifica", numeric: false, disablePadding: false, label: "Ultima modifica"},
];

export const mailsHead = [
	{id: "dataInserimento", numeric: false, disablePadding: false, label: "Data invio"},
	{id: "note", numeric: false, disablePadding: false, label: "Oggetto"},
	{id: "destinatario", numeric: false, disablePadding: false, label: "Destinatario"},
	{id: "operatore", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "allegati", numeric: false, disablePadding: false, label: "Allegati"},
];

export const ticketSearchHead = [
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data"},
	{id: "stato", numeric: false, disablePadding: false, label: "Stato"},
	{id: "sottoCategoria", numeric: false, disablePadding: false, label: "Categoria"},
	{id: "dettaglioRichiesta", numeric: false, disablePadding: false, label: "Richiesta"},
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
]

export const uploadHead = [
	{id: "id", numeric: false, disablePadding: false, label: "#"},
	{id: "fileName", numeric: false, disablePadding: false, label: "Nome file"},
	{id: "jobName", numeric: false, disablePadding: false, label: "Operazione"},
	{id: "operator", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "percentage", numeric: false, disablePadding: false, label: "%"},
	{id: "scheduledAt", numeric: false, disablePadding: false, label: "Inizio"},
	{id: "finishedAt", numeric: false, disablePadding: false, label: "Fine"},
	{id: "status", numeric: false, disablePadding: false, label: "Stato"},
]

export const myTicketHead = [
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data"},
	{id: "stato", numeric: false, disablePadding: false, label: "Stato"},
	{id: "sottoCategoria", numeric: false, disablePadding: false, label: "Categoria - sottocategoria"},
	{id: "priority", numeric: false, disablePadding: false, label: "Priorità"},
	{id: "data_ultima_modifica", numeric: false, disablePadding: false, label: "Ultima modifica"},
	{id: "dettaglioRichiesta", numeric: false, disablePadding: false, label: "Richiesta"},
]

export const gestioneTicketHead = [
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data creazione"},
	{id: "cell", numeric: false, disablePadding: false, label: "Telefono"},
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "sottoCategoria", numeric: false, disablePadding: false, label: "Categoria"},
	{id: "priority", numeric: false, disablePadding: false, label: "Priorità"},
];

export const practiceHistoryHead = [
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data ultima modifica"},
	{id: "stato", numeric: false, disablePadding: false, label: "Stato"},
	{id: "priority", numeric: false, disablePadding: false, label: "Priorità"},
	{id: "lastModify", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "allegato", numeric: false, disablePadding: false, label: "Allegato"},
	{id: "note", numeric: false, disablePadding: false, label: "Nota"},
];

export const practiceHistoryPaziente = [
	{id: "dataCreazione", numeric: false, disablePadding: false, label: "Data ultima modifica"},
	{id: "stato", numeric: false, disablePadding: false, label: "Stato"},
	{id: "note", numeric: false, disablePadding: false, label: "Nota"},
];

export const segnalazioniScuoleHead = [
	{id: "creationDate", numeric: false, disablePadding: false, label: "Data segnalazione"},
	{id: "phone", numeric: false, disablePadding: false, label: "Telefono"},
	{id: "details", numeric: false, disablePadding: false, label: "Categoria"},
	{id: "taxCode", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "priority", numeric: false, disablePadding: false, label: "Priorità"},
	{id: "creationOperator", numeric: false, disablePadding: false, label: "Operatore"},
	{id: "active", numeric: false, disablePadding: false, label: "In uso"},
	{id: "subCategoryDate", numeric: false, disablePadding: false, label: "Ultima modifica"},
];

export const usersHead = [
	{id: "username", numeric: false, disablePadding: false, label: "Username"},
	{id: "alias", numeric: false, disablePadding: false, label: "Alias"},
	{id: "dataRegistrazione", numeric: false, disablePadding: false, label: "Data registrazione"},
	{id: "gruppo", numeric: false, disablePadding: false, label: "Gruppo"},
	{id: "online", numeric: false, disablePadding: false, label: "Online"},
	{id: "password", numeric: false, disablePadding: false, label: "Password"},
	{id: "roles", numeric: false, disablePadding: false, label: "Ruoli"},
	{id: "scadenzaSessione", numeric: false, disablePadding: false, label: "Scadenza sessione"},
	{id: "ultimoAccesso", numeric: false, disablePadding: false, label: "Ultimo accesso"},
];

export const usersCmpHead = [
	{id: "username", numeric: false, disablePadding: false, label: "Username"},
	{id: "alias", numeric: false, disablePadding: false, label: "Alias"},
	{id: "dataRegistrazione", numeric: false, disablePadding: false, label: "Data registrazione"},
	{id: "scadenzaSessione", numeric: false, disablePadding: false, label: "Scadenza sessione"},
	{id: "ultimoAccesso", numeric: false, disablePadding: false, label: "Ultimo accesso"},
	{id: "roles", numeric: false, disablePadding: false, label: "Ruoli"},
];

export const appuntamentiHead = [
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "cell", numeric: false, disablePadding: false, label: "Telefono"},
	{id: "email", numeric: false, disablePadding: false, label: "Email"},
	{id: "dataNew", numeric: false, disablePadding: false, label: "Data appuntamento"},
	{id: "centroVaccinaleCurrent", numeric: false, disablePadding: false, label: "Centro vaccinale"},
	{id: "dose", numeric: false, disablePadding: false, label: "Dose"},
	{id: "tipoAppuntamento", numeric: false, disablePadding: false, label: "Tipo"},
];

export const disponibilitaManagerHead = [
	{id: "data", numeric: false, disablePadding: false, label: "Data disponibilità"},
	{id: "postiR", numeric: false, disablePadding: false, label: "Rimanenti/Totale"},
];

export const disponibilitaManagerHeadBig = [
	{id: "data", numeric: false, disablePadding: false, label: "Data disponibilità"},
	{id: "ospedale", numeric: false, disablePadding: false, label: "Ospedale"},
	{id: "postiR", numeric: false, disablePadding: false, label: "Rimanenti/Totale"},
	
	{id: "fascia1R", numeric: false, disablePadding: false, label: "8:30"},
	{id: "fascia2R", numeric: false, disablePadding: false, label: "8:45"},
	{id: "fascia3R", numeric: false, disablePadding: false, label: "9:00"},
	{id: "fascia4R", numeric: false, disablePadding: false, label: "9:15"},
	{id: "fascia5R", numeric: false, disablePadding: false, label: "9:30"},
	{id: "fascia6R", numeric: false, disablePadding: false, label: "9:45"},
	{id: "fascia7R", numeric: false, disablePadding: false, label: "10:00"},
	{id: "fascia8R", numeric: false, disablePadding: false, label: "10:15"},
	{id: "fascia9R", numeric: false, disablePadding: false, label: "10:30"},
	{id: "fascia10R", numeric: false, disablePadding: false, label: "10:45"},
	
	{id: "fascia11R", numeric: false, disablePadding: false, label: "11:00"},
	{id: "fascia12R", numeric: false, disablePadding: false, label: "11:15"},
	{id: "fascia13R", numeric: false, disablePadding: false, label: "11:30"},
	{id: "fascia14R", numeric: false, disablePadding: false, label: "11:45"},
	
	{id: "fascia15R", numeric: false, disablePadding: false, label: "12:00"},
	{id: "fascia16R", numeric: false, disablePadding: false, label: "12:15"},
	{id: "fascia17R", numeric: false, disablePadding: false, label: "12:30"},
	{id: "fascia18R", numeric: false, disablePadding: false, label: "12:45"},
	
	{id: "fascia19R", numeric: false, disablePadding: false, label: "13:00"},
	{id: "fascia20R", numeric: false, disablePadding: false, label: "13:15"},
	{id: "fascia21R", numeric: false, disablePadding: false, label: "13:30"},
	{id: "fascia22R", numeric: false, disablePadding: false, label: "13:45"},
	
	{id: "fascia23R", numeric: false, disablePadding: false, label: "14:00"},
	{id: "fascia24R", numeric: false, disablePadding: false, label: "14:15"},
	{id: "fascia25R", numeric: false, disablePadding: false, label: "14:30"},
	{id: "fascia26R", numeric: false, disablePadding: false, label: "14:45"},
	
	{id: "fascia27R", numeric: false, disablePadding: false, label: "15:00"},
	{id: "fascia28R", numeric: false, disablePadding: false, label: "15:15"},
	{id: "fascia29R", numeric: false, disablePadding: false, label: "15:30"},
	{id: "fascia30R", numeric: false, disablePadding: false, label: "15:45"},
	
	{id: "fascia31R", numeric: false, disablePadding: false, label: "16:00"},
	{id: "fascia32R", numeric: false, disablePadding: false, label: "16:15"},
	{id: "fascia33R", numeric: false, disablePadding: false, label: "16:30"},
	{id: "fascia34R", numeric: false, disablePadding: false, label: "16:45"},
	
	{id: "fascia35R", numeric: false, disablePadding: false, label: "17:00"},
	{id: "fascia36R", numeric: false, disablePadding: false, label: "17:15"},
	{id: "fascia37R", numeric: false, disablePadding: false, label: "17:30"},
	{id: "fascia38R", numeric: false, disablePadding: false, label: "17:45"},
	
	{id: "fascia39R", numeric: false, disablePadding: false, label: "18:00"},
	{id: "fascia40R", numeric: false, disablePadding: false, label: "18:15"},
	{id: "fascia41R", numeric: false, disablePadding: false, label: "18:30"},
	{id: "fascia42R", numeric: false, disablePadding: false, label: "18:45"},
	
	{id: "fascia43R", numeric: false, disablePadding: false, label: "19:00"},
	{id: "fascia44R", numeric: false, disablePadding: false, label: "19:15"},
	{id: "fascia45R", numeric: false, disablePadding: false, label: "19:30"},
	{id: "fascia46R", numeric: false, disablePadding: false, label: "19:45"},
];

export const disponibilitaManagerOspHead = [
	{id: "ospedale", numeric: false, disablePadding: false, label: "Ospedale"},
	{id: "postiR", numeric: false, disablePadding: false, label: "Rimanenti/Totale"},
];

export const alunniDocentiHead = [
	{id: "codF", numeric: false, disablePadding: false, label: "Codice fiscale"},
	{id: "nome", numeric: false, disablePadding: false, label: "Nome"},
	{id: "cognome", numeric: false, disablePadding: false, label: "Cognome"},
	{id: "dataNascita", numeric: false, disablePadding: false, label: "Data di nascita"},
	{id: "stato", numeric: false, disablePadding: false, label: "Stato"},
	{id: "positivo", numeric: false, disablePadding: false, label: "Segnala positivo "},
]
